import { postAddToCart } from './postAddToCart';
import { getCartMeta } from './getCartMeta';
import { getAddCartRecommend } from './getAddCartRecommend';

export const cartService = {
  postAddToCart,
  getCartMeta,
  getAddCartRecommend,
};
